import { Play } from "../../Common/SI";
import { ScoreFrequencyChart } from "./ScoreFrequencyChart";

import './Charts.css'
import { DurationFrequencyChart } from "./DurationFrequencyChart";

export interface ChartsProps {
	plays: Play[]
}

export function Charts(props: ChartsProps): JSX.Element {

	return (
		<div className="charts">
			<ScoreFrequencyChart plays={props.plays} />
			<DurationFrequencyChart plays={props.plays} />
		</div>
	)
}
